import React, { forwardRef, useEffect } from "react";
import styled from "styled-components";
import Dropdown from 'react-bootstrap/Dropdown';
import classNames from "classnames";
import parse from 'html-react-parser';
import { useDropdownContext } from "./DropdownContext";
import chevron from "./chevron-up.svg";
import IBuildrProps from "../../../utilities/IBuildrProps";

export interface IOptionDropdownProps extends IBuildrProps {
    className?: string;
    disabled?: boolean;
    text?: string;
    html?: string;
    eventKey?: string;
    isPlaceholder?: boolean;
}

export default styled(forwardRef(function(props: IOptionDropdownProps, ref: any) {
    const { selectedItem, setSelectedItem, open } = useDropdownContext();
    
    return (
        <Dropdown.Item
            key={Math.random()}
            tabIndex={open ? 0 : -1}
            data-id={props.cmsId}
            ref={ref}
            onSelect={() => setSelectedItem({text: props.text, eventKey: props.eventKey, html: props.html})}
            bsPrefix="custom-dropdown-item"
            className={classNames(props.className, {"disabled": props.disabled, "placeholder": props.isPlaceholder, "selected": !props.isPlaceholder && ((props.eventKey && (props.eventKey == selectedItem?.eventKey)) || (props.text && (props.text == selectedItem?.text)))})}
            disabled={props.disabled}
            eventKey={props.eventKey}>
                <span>{props.html ? parse(props.html) : `${props.text || ''}`}</span>
            
        </Dropdown.Item>
    );
}))`

color: var(--black, #2E2E2B);
font-family: "National2";
font-size: 0.88889rem;
font-weight: 400;
line-height: normal;
cursor: pointer;
display: block;
text-decoration: none;
height: 22px;

&:hover {
    color: inherit;
    text-decoration: none;
}

& + & {
    margin-top: 12px;
}

&.disabled {
    color: #000;
    opacity: 0.25;
    cursor: default;
}

&.selected span {
    font-weight: 500;
    border-bottom: 2px solid var(--redRock, #CE202E);
}

&.placeholder {
    position: relative;
    min-height: 41px;
    border-bottom: 1px solid #000;
    padding: 8px 0 16px 0;
    margin-bottom: 28px;
    color: var(--black, #2E2E2B);
    font-size: 0.88889rem;
    font-weight: 500;
    line-height: 100%;
}
&.placeholder::after {
    display: inline-block;
    content: "";
    position: absolute;
    top: 5px;
    right: 0;
    width: 24px;
    height: 24px;
    background: url(${chevron}) no-repeat 100% 100%;
    background-position-x: 5px;
}
`;